import type { ExamScaledReport } from '@examing/types';

export interface FinishedRow {
  skill: 'LISTENING' | 'READING' | 'WRITING' | 'SPEAKING';
  /** Graded: its score may be shown. Pending rows never carry one. */
  state: 'scored' | 'pending';
  raw?: number;
  max?: number;
  band?: number | null;
}

/**
 * One row per skill the report covers. A score is only handed out once it is
 * graded: Listening and Reading (marked at hand-in) show raw and band, Writing
 * and Speaking stay pending until every task or the whole recording set has a band.
 */
export function finishedRows(report: ExamScaledReport | null | undefined): FinishedRow[] {
  if (!report || report.standard !== 'IELTS') return [];
  const rows: FinishedRow[] = [];
  if (report.listening) rows.push({ skill: 'LISTENING', state: 'scored', raw: report.listening.raw, max: report.listening.max, band: report.listening.band });
  if (report.reading) rows.push({ skill: 'READING', state: 'scored', raw: report.reading.raw, max: report.reading.max, band: report.reading.band });
  if (report.writing) {
    rows.push(report.writing.pending || report.writing.band === null ? { skill: 'WRITING', state: 'pending' } : { skill: 'WRITING', state: 'scored', band: report.writing.band });
  }
  if (report.speaking) {
    rows.push(report.speaking.pending || report.speaking.band === null ? { skill: 'SPEAKING', state: 'pending' } : { skill: 'SPEAKING', state: 'scored', band: report.speaking.band });
  }
  return rows;
}

export const hasPendingRow = (rows: FinishedRow[]): boolean => rows.some((row) => row.state === 'pending');
